import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../environments/environment';
import { authUser } from '../interfaces';
import { AuthService } from '../services/auth.service';

declare const WebViewer: any;

@Component({
    selector: 'web-viewer',
    standalone: true,
    templateUrl: './webviewer.component.html',
    styleUrls: ['./webviewer.component.scss']
})
export class WebViewerComponent implements OnInit, OnDestroy {
    beenInitialized: boolean = false;
    wvInstance: any;
    constructor(
        private authService: AuthService
    ) { }
    ngOnDestroy(): void {
        this.deleteWebViewer();
    }
    user!: authUser;
    domain = environment.domain;
    @Input() set fileUrl(file: any) {
        if (!file) {
            return;
        }
        WebViewer({
            licenseKey: "sxFHe66TFOblwr4twdBt",
            path: '../../wv-resources/lib',
            filename: `${file.file_name}`,
            disabledElements: [
                'downloadButton',
                'languageButton'
            ],
            // initialDoc: '?withCredentials=true'
        }, this.viewer.nativeElement).then((instance: any) => {
            this.beenInitialized = true;
            this.wvInstance = instance;
            const { Core, UI } = instance;
            const token = this.authService.getAccessToken();
            instance.UI.loadDocument(`${this.domain}${file.download_link}`, {
                withCredentials: true,
                customHeaders: token ? { Authorization: `Bearer ${token}` } : {}
            });

            // adds a button to the header that on click sets the page to the next page
            UI.setHeaderItems((header: any) => {
                header.push({
                    type: 'actionButton',
                    img: 'https://icons.getbootstrap.com/assets/icons/caret-right-fill.svg',
                    onClick: () => {
                        const currentPage = Core.documentViewer.getCurrentPage();
                        const totalPages = Core.documentViewer.getPageCount();
                        const atLastPage = currentPage === totalPages;

                        if (atLastPage) {
                            Core.documentViewer.setCurrentPage(1);
                        } else {
                            Core.documentViewer.setCurrentPage(currentPage + 1);
                        }
                    }
                });
            });
        })







    }


    // Syntax if using Angular 8+
    // true or false depending on code
    @ViewChild('viewer', { static: true }) viewer!: ElementRef;



    ngOnInit() {
        this.wvDocumentLoadedHandler = this.wvDocumentLoadedHandler.bind(this);
        this.authService.authBufferSub$.subscribe(user => {
            this.user = user || {} as authUser;
        });
    }

    wvDocumentLoadedHandler(): void {
        // you can access docViewer object for low-level APIs
        const instance = this.wvInstance;
        const { Core } = instance;

        // adding an event listener for when a document is loaded
        Core.documentViewer.addEventListener('documentLoaded', () => {
            console.log('document loaded');
        });

        // adding an event listener for when the page number has changed
        Core.documentViewer.addEventListener('pageNumberUpdated', (pageNumber: number) => {
            console.log(`Page number is: ${pageNumber}`);
        });
        // see https://pdfjs.express/api/WebViewerInstance.html for the full list of low-level APIs
    }

    deleteWebViewer(): void {
        console.log("delete WebViewer", this.viewer);
        if (this.viewer) {
            this.viewer.nativeElement.remove(); // Clean up WebViewer resources
        }
    }
}